<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row class="mx-md-n3 mx-1">
        <div class="col-sm col-12 mb-sm-0 mb-3">
          <b-input-group>
            <b-form-input
              v-model="filter"
              @keyup.enter="findAll"
              placeholder="Procurar por..."
            />
            <b-input-group-append>
              <b-button size="md" text="Button" variant="outline-info" @click.passive="findAll">
                <i class="cui-magnifying-glass"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-sm-auto col-12">
          <input type="file" ref="uploadFileInput" style="display: none" @change="uploadFile">
          <button type="button" class="btn btn-success mobile-btn-100" @click="$refs.uploadFileInput.click()">
            <i class="fa fa-upload"></i> Upload
          </button>
        </div>
      </b-row>
    </b-card>

    <div v-if="loadingRows" class="row mx-0">
      <div class="col-12 mb-5 pb-5">
        <loading-animation />
      </div>
    </div>

    <div v-if="!loadingRows && (!assets || !assets.length)" class="row mx-0">
      <div v-if="!loadingRows && (!assets || !assets.length)" class="col-12 text-center bg-light py-3">
        Nenhum Arquivo encontrado
      </div>
    </div>
    <div v-if="!loadingRows && assets && assets.length" class="row mx-0 border">
      <div v-for="(asset, index) in assets" class="col-xl-2 col-sm-6 col-12 p-2 mb-2"
        :key="index" style="word-wrap: break-word;" @click="assetClicked(asset)" :class="{ 'cursor-pointer': onClick }">
        <h6 class="my-1">{{asset.name}}</h6>
        <img v-if="asset.type === 'I'" :src="asset.url" width="120">
        <!--<button class="btn btn-link" @click="assetClicked(index)">Copiar URL</button>-->
      </div>
    </div>

    <nav class="mt-3">
      <b-pagination
        v-if="totalRows"
        align="center"
        :limit="10"
        :total-rows="totalRows"
        :per-page="perPage"
        prev-text="Anterior"
        next-text="Próximo"
        v-model="currentPage"
        @change="pageChanged"
        :disabled="loadingRows"/>
    </nav>
  </div>
</template>

<script>
import { LoadingAnimation } from '@/components/loaders'
import { httpClient } from '@/service'
import shared from '@/shared/shared'

export default {
  name: 'assets',
  components: { LoadingAnimation },

  props: {
    additionalConditions: {
      type: Array
    },
    onClick: {
      type: Function
    }
  },

  data() {
    return {
      currentPage: 1,
      perPage: 30,
      totalRows: null,
      assets: [],
      loadingRows: false,
      filter: '',
    }
  },

  methods: {
    findAll() {
      let conditions = [];

      if (this.filter && this.filter.length) {
        conditions.push({
          field: 'name',
          conditionalOperator: 'LIKE_START',
          value: this.filter
        });
      }

      if (this.additionalConditions) {
        conditions.push(...this.additionalConditions);
      }

      this.loadingRows = true;
      httpClient.post(
        `${process.env.VUE_APP_API_URL}assets/condition?page=${this.currentPage - 1}&size=${this.perPage}&sort=type,asc&sort=createdAt,desc`, {
        conditions: conditions
      }).then(({ data }) => {
        this.loadingRows = false;
        this.assets = data.data.content;
        this.totalRows = data.data.totalElements;
      })
      .catch((error) => {
        this.loadingRows = false;
        if (error.message) {
          this.$notify.error(error)
        }
      });
    },

    pageChanged(page) {
      this.currentPage = page;
      this.findAll();
    },

    uploadFile($event) {
      if (this.$refs.uploadFileInput
        && this.$refs.uploadFileInput.files
        && this.$refs.uploadFileInput.files.length) {
        this.loadingRows = true;
        let formData = new FormData();
        formData.append("file", this.$refs.uploadFileInput.files[0]);
        httpClient.post(`${process.env.VUE_APP_API_URL}assets`, formData).then(({ data }) => {
          this.loadingRows = false;
          this.$notify.success('Arquivo salvo com sucesso');

          if (!this.assets) {
            this.assets = [];
          }

          this.assets.unshift(data.data);
        })
        .catch((error) => {
          this.loadingRows = false;
          if (error.message) {
            this.$notify.error(error)
          }
        });
      }
    },

    assetClicked(asset) {
      if (this.onClick) {
        this.onClick(asset);
      }
    }
  }
}
</script>
